//import Immutable from 'immutable';

//import Home from '../Home'
import Search from '../Search'
import ReportRes from '../ReportRes'
import Refunds from '../Refunds'
import Sales from '../Sales'

//import {MENU_SET_FILTER, APP_CLEAR, USER_SET_AGENT} from '../constants/actionTypes';
import {MENU_SET_FILTER, APP_CLEAR} from '../constants/actionTypes';
//export const initialState = Immutable.Record({ 
export const initialState = { 
  positions: [
    // {
    //   text: 'Home',
    //   path: '/',
    //   exact: true,
    //   comp: {Home},
    //   isLogged: false,
    // },
    {
      text: 'Rezerwuj',
      path: '/search',
      exact: false,
      comp: {Search},
      isLogged: true
    },    
    {
      text: 'Rezerwacje',
      path: '/reservations',
      exact: false,
      comp: {ReportRes},
      isLogged: true
    },
    {
      text: 'Zwroty',
      path: '/refunds',
      exact: false,
      comp: {Refunds},
      isLogged: true
    },
    {
      text: 'Raport sprzedaży',
      path: '/sales',
      exact: false,
      comp: {Sales},
      isLogged: true
    },      
  ],
  filter: {
    isLogged: false
  }  
};
//});

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case MENU_SET_FILTER:
      return {
        ...state, 
        filter: action.menuFilter
      }     
    case APP_CLEAR:
      return {
        ...state,
        ...initialState
      }  
    default:
      return state;
   }
};
 
export default menuReducer;


// WEBPACK FOOTER //
// ./src/reducers/menuReducer.js